import { DownOutlined, RightOutlined, UpOutlined } from "@ant-design/icons";
import { theme } from "antd";
import { CSSProperties, Dispatch, SetStateAction } from "react";
import { Hover } from "./Hover";

export function ContainerArrow({
  size = 24,
  ...props
}: {
  opened?: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  size?: number;
  mobile?: boolean; // uses Mobile conventions instead of Select conventions
}) {
  const { token } = theme.useToken();
  return (
    <Hover
      baseStyle={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        width: size,
        height: size,
        cursor: "pointer",
        color: token.colorTextSecondary,
      }}
      hoverStyle={{
        backgroundColor: token.colorFill,
      }}
    >
      <div onClick={() => props.setOpened((opened) => !opened)}>
        {props.opened ? (
          props.mobile ? (
            <DownOutlined style={iconCss} />
          ) : (
            <UpOutlined style={iconCss} />
          )
        ) : props.mobile ? (
          <RightOutlined style={iconCss} />
        ) : (
          <DownOutlined style={iconCss} />
        )}
      </div>
    </Hover>
  );
}

const iconCss: CSSProperties = {
  display: "block",
  fontSize: 11,
  color: "inherit",
  transform: "scaleY(0.8)",
};
